import React, {useState, useEffect} from "react";
import DetailsComponent from "../../course_details/components/DetailsComponent";
import ExperienceComponent from "./ExperienceComponent";
import {Content} from "../../../styles/GlobalStyles";

export default function ExperienceContainer({contact, data}) {
   return (
      <Content color="plum">
         <DetailsComponent
            title="Experiencias domecq academy"
            iconTitle={require("../../../assets/icons/people_group.png")}
            full={true}
            column={true}
            classname="notBorder"
            iconClass="sLarge"
         >
            {/* {console.log(data)} */}
            {data &&
               data.map((item) => {
                  return <ExperienceComponent data={item} key={item.idCourse} contact={contact} />;
               })}
         </DetailsComponent>
      </Content>
   );
}
